export const HOMEPAGE_REVIEWS = {
  headingLine1: 'Over 30,000',
  headingLine2Accent: '5-star',
  headingLine2Rest: ' reviews',
}

export const RECIPE_VIDEOS = [
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt55597cd1408553e0/6a58ab5c702d1430ec7cb285/green_goodness_bowl.mp4',
    recipeName: 'Green Goodness Bowl With Boiled Egg And Sweet Potato',
    rating: '4.5',
    tile: 'green_goodness',
  },
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt1acec7383b66ebad/6a58ab5cf41cd7fff4dea536/fish_&_chips_and_crushed_peas.mp4',
    recipeName: 'Ultimate Fish & Chips With Stout-Battered Sole And Crushed Peas',
    rating: '4.6',
    tile: 'fish_and_chips',
  },
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt8955d60aa256a135/6a58ab5ce828995017eb1382/slow_ccoked_beef_brisket_birra_tacos.mp4',
    recipeName: 'Slow Cooked Beef Brisket Birria Tacos',
    rating: '5.0',
    tile: 'beef_brisket',
  },
]
